import { supabase } from "@/integrations/supabase/client";

/**
 * Single source of truth for which admin account owns the scheduling calendar.
 * Stored in app_settings (key: 'primary_admin') and read via the
 * get_primary_admin_id() database function so every booking path agrees.
 */
const FALLBACK_PRIMARY_ADMIN_ID = '0f2637ec-4a57-4a32-846b-66ec41bcce15';

let cachedId: string | null = null;
let inFlight: Promise<string> | null = null;

export async function getPrimaryAdminId(): Promise<string> {
  if (cachedId) return cachedId;
  if (inFlight) return inFlight;

  inFlight = (async () => {
    try {
      const { data, error } = await supabase.rpc('get_primary_admin_id');
      if (error) throw error;
      const id = (data as string | null) || FALLBACK_PRIMARY_ADMIN_ID;
      cachedId = id;
      return id;
    } catch (error) {
      console.error('Error fetching primary admin id, using fallback:', error);
      return FALLBACK_PRIMARY_ADMIN_ID;
    } finally {
      inFlight = null;
    }
  })();

  return inFlight;
}

export { FALLBACK_PRIMARY_ADMIN_ID };
